const DataHolder = ({ data, type }) => {
  return (
    <div
      className={`supply-prices__holder__data-holder supply-prices__holder__data-holder--${type} text-center fw-bold fsize--6`}
    >
      <span dir="rtl" translate="no">
        {' '}
        {data}
      </span>
    </div>
  );
};

export default DataHolder;
